import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { updateOutgoingQuoteLineItem } from "MODULES/OutgoingQuotes/actions";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import {
  transformOQInputValues,
  transformOQOutputValues
} from "MODULES/shared/helpers";
import {
  FOLLOW_UP_FEEDBACK,
  HAS_FOLLOW_UP_FEEDBACK
} from "MODULES/OutgoingQuotes/constants";
import { ID, INVENTORY_ID } from "APP_ROOT/constants";
import { DOM, PART } from "MODULES/parts/constants";
import Form from "./Form";

function EditPart({ open, close, onSubmit, quote, selectedLineItem }) {
  const initialValues = !selectedLineItem
    ? {}
    : {
        [HAS_FOLLOW_UP_FEEDBACK]: selectedLineItem.get(FOLLOW_UP_FEEDBACK),
        part_id: selectedLineItem.getIn([PART, ID]),
        ...transformOQInputValues(selectedLineItem.toJS()),
        inventory_id:
          selectedLineItem.get(INVENTORY_ID) &&
          selectedLineItem.get(INVENTORY_ID).toString(),
        include_dom: !!selectedLineItem.get(DOM)
      };

  return (
    <Modal open={open} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Part</h4>
      </Header>
      <Form
        close={close}
        quote={quote}
        initialValues={initialValues}
        onSubmit={onSubmit}
        selectedLineItem={selectedLineItem && selectedLineItem.toJS()}
      />
    </Modal>
  );
}

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data =>
    dispatch(
      updateOutgoingQuoteLineItem(
        transformOQOutputValues(data),
        ownProps.selectedLineItem.get(ID)
      )
    )
}))(EditPart);

EditPart.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  selectedLineItem: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/Parts/EditPart.jsx